import { Injectable, NgZone, forwardRef } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
  fromDocRef,
} from 'angularfire2/firestore';
import 'rxjs/add/operator/take';
import * as firebase from 'firebase';

import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { take, map, combineAll } from 'rxjs/operators';
import { combineLatest } from 'rxjs/observable/combineLatest';
import 'rxjs';
import 'rxjs/add/operator/combineAll';

import 'rxjs/add/observable/combineLatest';


@Injectable()
export class FollowService {
  followingCollection: AngularFirestoreCollection<any>;
  followerCollection: AngularFirestoreCollection<any>;

  followingDoc: AngularFirestoreDocument<any>;
  followersDoc: AngularFirestoreDocument<any>;

  constructor(private db: AngularFirestore) {
    this.followingCollection = this.db.collection("following");
    this.followerCollection = this.db.collection("follower");
    var docRef = firebase.firestore();
    var docRef2 = firebase.firestore();
  }

  test(userId: string) {
    return this.db.collection('followers').doc(`${userId}`);
  }

  getFollow(followerId) {
    return this.db.doc(`followers/${followerId}`);
  }

  getFollowers(userId: string) {
    // used to build the follower count
    return this.db.doc(`followers/${userId}`).valueChanges();
  }

  getFollowing(followerId, followedId) {
    // Used to see if user A is following user B
    console.log(followerId, followedId);
    //return this.db.collection('following').doc(`${followerId}`);
    //return this.db.collection('following').doc(`${followerId}`).take(1).map(data => data[followedId]);
    return this.db
      .collection('following')
      .doc(`${followerId}`)
      .valueChanges()
      .take(1)
      .map(data => data[followedId]);
  }

  public getFollowers$(id: string): Observable<any> {
    console.log('test');
    if (!id) {
      return Observable.of([]);
    }

    return this.db
      .collection('following')
      .doc(id)
      .valueChanges()
      .switchMap((f_id_array: any) => {
        const followersRefArray = [];
        for (let f_id in f_id_array) {
          if (f_id_array.hasOwnProperty(f_id) && f_id_array[f_id] === true) {
            followersRefArray.push(
              this.db
                .collection('users')
                .doc(f_id)
                .valueChanges()
            );
          }
        }
        return Observable.combineLatest(followersRefArray);
      });
  }

  public getFollowing$(id: string): Observable<any> {
    if (!id) return Observable.of([]);
    return this.db
      .collection('followers')
      .doc(id)
      .valueChanges()
      .switchMap((f_id_array: any) => {
        console.log('My => f_id_array', f_id_array);

        for (var key in f_id_array) {
          if (f_id_array.hasOwnProperty(key) && f_id_array[key] === true) {
            console.log(key + ' -> ' + f_id_array[key]);
          }
        }

        const followersRefArray = [];
        for (let f_id in f_id_array) {
          if (f_id_array.hasOwnProperty(f_id) && f_id_array[f_id] === true) {
            followersRefArray.push(
              this.db
                .collection('users')
                .doc(f_id)
                .valueChanges()
            );
          }
        }
        return Observable.combineLatest(followersRefArray);
      });
  }

  follow(followerId: string, followedId: string) {
    this.db.doc(`followers/${followedId}`).set({ [followerId]: true }, {merge: true});
    this.db.doc(`following/${followerId}`).set({ [followedId]: true }, {merge: true});
  }

  unfollow(followerId: string, followedId: string) {
    console.log('unfollow');
    this.db.doc(`followers/${followedId}`).set({ [followerId]: false }, {merge: true});
    this.db.doc(`following/${followerId}`).set({ [followedId]: false }, {merge: true});
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/services/follow.service.ts